import React from 'react';
import FormTitle from '../../FormTitle';
import { useIndicatorsContext } from '../../../context/indicatorsContext/IndicatorsContext';
import { Form } from 'react-bootstrap';
import { testSectionDefaultFormValues } from '../../../constants/defaultValues';
import _ from 'lodash';

const TestComponent = () => {
  const { testSection } = useIndicatorsContext();

  const {
    testSectionFormMethods: { onFormChange, formValues },
  } = testSection;

  const onChange = (e) => {
    let value = e.target.value;
    // Prevent entering '.' at all
    value = value.replace(/\./g, '');
    e.target.value = value;

    // Remove leading zeros if value has more than one digit
    if (/^0\d+/.test(value)) {
      value = value.replace(/^0+/, '');
      e.target.value = value;
    }
    if (value === '' || isNaN(value) || Number(value) < 0) {
      e.target.value = 0;
    } else if (!Number.isInteger(Number(value))) {
      e.target.value = Math.floor(Number(value));
    }
    onFormChange(e);
  };

  return (
    <div>
      <FormTitle>Pruebas en procedimientos admitidos</FormTitle>

      <Form>
        <Form.Group controlId="offered">
          <Form.Label>Ofertadas</Form.Label>
          <Form.Control
            type="number"
            name="offered"
            onInput={onChange}
            value={_.defaultTo(formValues.offered, testSectionDefaultFormValues.offered)}
            min={0}
          />
        </Form.Group>

        <Form.Group controlId="admitted">
          <Form.Label>Admitidas</Form.Label>
          <Form.Control
            type="number"
            name="admitted"
            onInput={onChange}
            value={_.defaultTo(formValues.admitted, testSectionDefaultFormValues.admitted)}
            min={0}
          />
        </Form.Group>

        <Form.Group controlId="unburdened">
          <Form.Label>Desahogadas</Form.Label>
          <Form.Control
            type="number"
            name="unburdened"
            onInput={onChange}
            value={_.defaultTo(formValues.unburdened, testSectionDefaultFormValues.unburdened)}
            min={0}
          />
        </Form.Group>
      </Form>
    </div>
  );
};

export default TestComponent;
